import { FormGroup } from "@angular/forms";

export interface RuleEngine {}

/** Placeholder for IN/NOT IN rule value fields that accept pipe-delimited multiple values.
export const RULE_VALUE_DELIMITER_PLACEHOLDER =
  "Use delimiter pipe symbol | to add multiple values"; */

/** Placeholder for chip-based IN/NOT IN rule value input. */
export const RULE_VALUE_CHIP_PLACEHOLDER =
  "Enter value and press Enter to add more.";

/** Hint shown below selected rule values. */
export const RULE_VALUE_CHIP_HINT =
  "Add one value at a time. You can add up to 100 values.";

/** Maximum values allowed for IN/NOT IN rules. */
export const RULE_VALUE_MAX_COUNT = 100;

export interface FileNode {
  key: string;
  children?: FileNode[];
  leaf?: any;
  uniqueId?: any;
}

export interface Rule {
  rulenumber: number;
  rulename?: string;
  field?: string;
  operator?: string;
  value?: string;
  ruletype?:string,
  param?:string
}

export interface PredicateFilter{
nodeName: string,
nodePath:string,
attributes:string[],
formGroup:any
}

export interface RuleExpression{
  rulenumber: number,
  rulename:string,
  field: string,
  operation: string,
  value:string,
  delimiter: string,
  ruletype?:string,
  param?:string
}

export interface RuleExpressoins{
  rules: RuleExpression[],
  ruleSatisfaction: string
}

export interface SubConditions{}

export interface PredicateData{
  nodeName:string,
  attributes: string[],
  nodePath:string,
  formGroup?:FormGroup
}

export interface ConditionGroup{
  conditions: string[],
  operator: string
}

export interface NestedGroups{
  groups:string[],
  operators: string[]
}
export interface ReturnResponse<T = any> {
  status: string;
  statusmessage: string;
  responsebody: T;
  extendedattributes: any;
  responsecontent: any;
  Attributes: string;
  log: any;
  runinfo: string;
}

export interface REMethodParameters {
  MethodName: string;
  Label: string;
  ShowXPath: boolean;
  /** Pipe-separated allowed values from API (e.g. ">||>=||<=||<||=" or "a|b|c"). */
  Value?: string;
  /** "constant" = use Value as dropdown options; "API" + Value "Lookup" = load XML mappings. */
  ValueType?: string;
}

export interface REMethodNames {
  MethodNames: string[];
}
